
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatAs, getAsLongDate, DateFnsFormats, getTimeOnly } from '../../../../common-client2/src/services/ukgDateTime';
import { SymbolicAmount } from '../../../Enums';
import './AvailableTimeOffRequest.scss';

const AvailableTimeOffRequest = ({
    timeOffRequest, error
}) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'validationError' });
    let content = <></>;
    if (!timeOffRequest && !error) {
        return content
    }

    if (error) {
        content = (<div>
            <span>{t(error)}</span>
        </div>);
    } else if (timeOffRequest) {
        const { startDate, startTime, payCode, duration, symbolicAmount } = timeOffRequest;
        const date = getAsLongDate(startDate);
        let info = `${payCode.qualifier}`;

        if (symbolicAmount.id === SymbolicAmount.hours) {
            const time = getTimeOnly(`${formatAs(startDate, DateFnsFormats.YMD)}T${startTime}`);
            info += ` ${time} (${duration})`;
        }

        content = (<div className="detail-wrapper">
            <div className="request-date">
                <span>{date}</span>
            </div>
            <div>
                <span>{info}</span>
            </div>
        </div>);
    }

    return (
        <div className="available-time-off-request">
            <div className="title-wrapper">
                <span className="headline-h-500">Time-off request</span>
            </div>
            {content}
        </div>
    );
};


export default AvailableTimeOffRequest;
